import React, { useContext, useEffect } from "react";
//
import { Routes, Route } from "react-router-dom";
// components
import NotFound from "../pages/error/NotFound";
import NotAllow from "../pages/error/NotAllow";
// import RouteProtectedHoc from "./RouteProtectedHoc";
//
import { StoreContext } from "../store/StoreProvider";
// config
import { routes } from "../config/App-layout";
// utils
import { allowGetIn } from "./utils";

const RouteManager = () => {
  //

  // store
  const [state] = useContext(StoreContext);
  const { user } = state;
  const { role } = user;

  return (
    <Routes>
      {Array.isArray(routes) &&
        routes
          .filter((r) => r.public)
          .map((route, idx) => {
            const { path, element: Element } = route;
            if (allowGetIn(route, role)) {
              return (
                <Route
                  exact
                  key={idx.toString()}
                  path={path}
                  element={<Element />}
                />
              );
            }
            return (
              <Route
                exact
                key={idx.toString()}
                path={path}
                element={<NotAllow />}
              />
            );
          })}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default RouteManager;
